<template>
  <div id="app">
    <ImagemComFallback
      :src="background"
      srcDefault="/assets/imgs/background.svg"
      class="custom-backgroud"
      id="background">
      <ImagemComFallback
        :src="logo"
        srcDefault="/assets/imgs/logo.svg"
        class="custom-loading"
        id="loading"
      />
  </ImagemComFallback>
  </div>
</template>

<script>
export default {
  props: {
    preview: {
      type: Boolean,
      default: false
    },
    previewImages: Object
  },
  computed: {
    background () {
      if (this.previewImages?.background) {
        return this.previewImages?.background
      }
      return this.$theme.background || '/assets/imgs/background.svg'
    },
    logo () {
      if (this.previewImages?.logoLoading) {
        return this.previewImages?.logoLoading
      }
      return this.$theme.logoLoading || '/assets/imgs/logo-inverted.svg'
    }
  },
}
</script>

<style scoped>
  .custom-backgroud {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 1;
  }

  .custom-loading {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 400px;
    max-height: 400px;
    width: 100%;
    height: auto;
    object-fit: contain;
    z-index: 2;
    background-repeat: no-repeat;
    background-size: contain;
    animation: 3s ease 0s normal forwards 1 fadein;
    animation-iteration-count: infinite;
  }
</style>
